"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApShortLogo = void 0;
var React = require("react");
var types_1 = require("../../utils/types");
var styles_1 = require("./styles");
exports.ApShortLogo = function (_a) {
    var dimensions = _a.dimensions, theme = _a.theme, className = _a.className;
    return (React.createElement(styles_1.StyledSvgWrapper, { className: "ap-short-logo " + (className ? className : ''), dimensions: { width: dimensions.width } },
        React.createElement(styles_1.StyledSvg, { role: "img", dimensions: { width: dimensions.width }, viewBox: "0 0 20 20", preserveAspectRatio: "xMidYMid meet", x: "0", y: "0", theme: theme },
            React.createElement("path", { d: "M14.854 20h4.117L11.65 0H7.32L0 20h4.01l8.786-5.777h-6.69L9.485 5z" }),
            React.createElement("title", { id: "ap-short-logo" }, "Alix Partners"))));
};
exports.ApShortLogo.defaultProps = {
    dimensions: {
        width: '20px'
    },
    theme: types_1.LIGHT
};
//# sourceMappingURL=ApShortLogo.js.map